import { normalizePhone } from "./normalize";
/**
 * Display spelling for a stored phone number.
 *
 * Storage is canonical and unreadable on purpose — `+79123841283` is one
 * string with no separators, which is what a UNIQUE index and a search term
 * need. Printed straight into a table cell it forces the reader to count
 * digits to tell `+79123841283` from `+79123481283`, so every display site
 * runs the value through here first.
 *
 * The grouping is `+7 (912) 384-12-83`, byte-for-byte the RU_MASK the
 * PhoneInput types into — the same number must not look like two different
 * numbers depending on whether the field is being edited or read.
 */
const RU_CANONICAL = /^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/;
export function formatPhone(value) {
    // Every call site would otherwise repeat this guard, and a missing phone is
    // the normal case for an optional contact field, not an error.
    if (!value)
        return "";
    // normalizePhone already owns the definition of "Russian number" — the 8→7
    // trunk rewrite and the bare-ten-digit assumption both live there. Matching
    // on its output means this formatter cannot drift from it.
    const match = RU_CANONICAL.exec(normalizePhone(value));
    if (!match) {
        // Foreign numbers and junk pass through untouched. Grouping differs per
        // country and guessing it wrong is worse than not grouping — the same
        // call the PhoneInput mask makes. Junk is returned as given rather than
        // thrown on, so a bad row renders visibly wrong instead of blanking the
        // screen.
        return value;
    }
    const [, area, first, second, third] = match;
    return `+7 (${area}) ${first}-${second}-${third}`;
}
